export default __webpack_public_path__ + "static/media/emoji4.fdcdd48d.svg";